module.exports = __webpack_public_path__ + "static/media/LOGO CIA GRAD.ead903bb.png";